<template>
<div class="buildserviceMovie" data-nosnippet="true">
  <iframe class="buildserviceMovie_src" src="https://www.youtube.com/embed/QsKNcvKASrE" loading="lazy" frameborder="0"></iframe>
</div>
</template>

<script>
export default {
  name: 'Movie',
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.buildserviceMovie {
  @include bpOnlyPc() {
    max-width: 900px;
  }
  @include bpOnlySp() {
    max-width: 375px;
  }
  position: relative;
  width: 100%;
  margin: auto;
  &_src {
    @include bpOnlyPc() {
      height: 500px;
      top: -250px;
    }
    @include bpOnlySp() {
      height: 250px;
      top: -125px;
    }
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    // border: 1px solid $gray;
  }
}

</style>
